/* Wear Your Music — header behavior
   Desktop dropdowns are pure CSS (:hover / :focus-within).
   This script handles: mobile drawer, mobile accordions,
   Escape-to-close, and the search modal close button. */

(function () {
  var BREAKPOINT = 990;
  var section = document.getElementById('shopify-section-header-new') || document;
  var header = section.querySelector('.wym-header');
  if (!header) return;

  var burger = section.querySelector('.js-menu-toggle');

  function isMobile() {
    return window.innerWidth < BREAKPOINT;
  }

  function setDrawer(open) {
    header.classList.toggle('nav-active', open);
    document.documentElement.classList.toggle('wym-nav-open', open);
    if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  if (burger) {
    burger.addEventListener('click', function () {
      setDrawer(!header.classList.contains('nav-active'));
    });
  }

  section.querySelectorAll('.js-menu-close').forEach(function (el) {
    el.addEventListener('click', function () {
      setDrawer(false);
    });
  });

  /* Parent items: accordion on mobile; on desktop suppress dead '#' links */
  section.querySelectorAll('.wym-nav__item.has-panel > .wym-nav__link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var item = link.parentElement;
      if (isMobile()) {
        e.preventDefault();
        var open = !item.classList.contains('open');
        item.classList.toggle('open', open);
        link.setAttribute('aria-expanded', open ? 'true' : 'false');
      } else if (link.getAttribute('href') === '#' || link.getAttribute('href') === '') {
        e.preventDefault();
      }
    });
  });

  /* Escape closes drawer, accordions, open panels, and the search modal */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    setDrawer(false);
    section.querySelectorAll('.wym-nav__item.open').forEach(function (item) {
      item.classList.remove('open');
      var link = item.querySelector(':scope > .wym-nav__link');
      if (link) link.setAttribute('aria-expanded', 'false');
    });
    var search = section.querySelector('.wym-search details[open]');
    if (search) search.removeAttribute('open');
    if (document.activeElement && header.contains(document.activeElement)) {
      document.activeElement.blur();
    }
  });

  /* Search modal close button */
  var searchClose = section.querySelector('.js-search-close');
  if (searchClose) {
    searchClose.addEventListener('click', function () {
      var details = searchClose.closest('details');
      if (details) details.removeAttribute('open');
    });
  }

  /* Leaving mobile widths resets drawer state */
  window.addEventListener('resize', function () {
    if (!isMobile()) setDrawer(false);
  });

  /* Sticky condensed bar: pin once the full header has scrolled away,
     unpin when scrolling back to the header's natural position. */
  var sectionWrap = document.getElementById('shopify-section-header-new');
  if (sectionWrap) {
    var isFixed = false;
    var naturalHeight = header.offsetHeight;

    function wrapTop() {
      return sectionWrap.getBoundingClientRect().top + window.scrollY;
    }

    function pin() {
      isFixed = true;
      naturalHeight = header.offsetHeight;
      sectionWrap.style.height = naturalHeight + 'px';
      header.classList.add('wym-header--fixed');
      /* two frames so the hidden state paints before the slide-in */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          header.classList.add('wym-header--animate', 'wym-header--revealed');
        });
      });
    }

    function unpin() {
      isFixed = false;
      header.classList.remove('wym-header--fixed', 'wym-header--revealed', 'wym-header--animate');
      sectionWrap.style.height = '';
    }

    function onScroll() {
      var y = window.scrollY;
      if (!isFixed) {
        if (y > wrapTop() + naturalHeight) pin();
      } else {
        if (y <= wrapTop() + 2) unpin();
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      if (!isFixed) naturalHeight = header.offsetHeight;
      else sectionWrap.style.height = '';
      if (isFixed) {
        /* re-measure natural height with the bar unpinned off-screen */
        header.classList.remove('wym-header--fixed');
        naturalHeight = header.offsetHeight;
        header.classList.add('wym-header--fixed');
        sectionWrap.style.height = naturalHeight + 'px';
      }
    });
    onScroll();
  }
})();
